import type { ISubscribeDataLayer } from '@/types/DataLayer'

const EVENT_NAME = 'subscription_popup'
const GENERIC_EVENT_NAME = 'subscription_popup'

export const useSubscribeDataLayer = () => {
  const route = useRoute()
  const pageType = computed(() => route.path.split('/').filter(Boolean).pop() ?? '')
  const localeStore = useLocaleStore()

  function pushSubscribeBlockDataLayer(data: ISubscribeDataLayer) {
    pushToDataLayer({
      event: EVENT_NAME,
      generic_event_name: GENERIC_EVENT_NAME,
      site_language: localeStore.selectedLanguage,
      page_type: pageType.value,
      ...data
    })
  }

  return {
    pushSubscribeBlockDataLayer
  }
}
